import { render, staticRenderFns } from "./UserPicker.vue?vue&type=template&id=f87a9198&"
import script from "./UserPicker.js?vue&type=script&lang=js&"
export * from "./UserPicker.js?vue&type=script&lang=js&"
import style0 from "./UserPicker.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports